import React from "react";

function DogForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="dogForm">
      {/* 🐶 İt Cinsi */}
      <div>
        <h3>İt Cinsi <span>*</span></h3>
        <select name="dogBreed" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Alman Çobanı">Alman Çobanı</option>
          <option value="Labrador">Labrador</option>
          <option value="Golden Retriever">Golden Retriever</option>
          <option value="Haski">Haski</option>
          <option value="Pitbull">Pitbull</option>
          <option value="Bulldog">Bulldog</option>
          <option value="Doberman">Doberman</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* 📅 Yaş */}
      <div>
        <h3>Yaş <span>*</span></h3>
        <input
          type="number"
          name="age"
          min="0"
          max="10"
          required
          placeholder="Yaşı daxil edin"
          onChange={handleChange}
        />
      </div>

      {/* 🚹 Cinsiyyət */}
      <div>
        <h3>Cinsiyyəti <span>*</span></h3>
        <select name="gender" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
        </select>
      </div>

      {/* ⚖️ Çəki */}
      <div>
        <h3>Çəki (kg) <span>*</span></h3>
        <input
          type="number"
          name="weight"
          min="0.5"
          max="80"
          step="0.1"
          required
          placeholder="Çəkini daxil edin"
          onChange={handleChange}
        />
      </div>

      {/* 🎨 Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* 🏥 Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
          <option value="Peyvənd olunmuş">Peyvənd olunmuş</option>
        </select>
      </div>

      {/* 💉 Peyvəndlər */}
      <div>
        <h3>Peyvəndlər <span>*</span></h3>
        <select name="vaccinated" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      {/* 📜 Nəsil Şəcərəsi */}
      <div>
        <h3>Nəsil Şəcərəsi <span>*</span></h3>
        <select name="pedigree" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>

      {/* 🏠 Qəfəs və aksesuarlar */}
      <div>
        <h3>Qəfəs və aksesuarlar daxildirmi? <span>*</span></h3>
        <select name="includesAccessories" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>
    </div>
  );
}

export default DogForm;
